import { Col, Input, Row } from 'antd';
import React, { useMemo } from 'react';
import { useGetMarketplaces } from '../../../../utils/api/marketplaces/useGetMarketplaces';
import MarketplaceList from './MarketplaceList';

const Marketplaces = () => {
  const { marketplaces, isLoading: isLoadingMarketplaces } = useGetMarketplaces(
    { is_active: true }
  );

  const filteredMarketplaces = useMemo(() => marketplaces);

  return (
    <Row gutter={16}>
      <Col span={24}>
        <h1 style={{ margin: '16px 0' }}>Marketplaces</h1>
        <Input
          placeholder="Rechercher une marketplace"
          disabled
          size="small"
          style={{ width: 250, marginBottom: 16 }}
        />
      </Col>
      <Col span={24}>
        <MarketplaceList
          filteredMarketplaces={filteredMarketplaces}
          isLoadingMarketplaces={isLoadingMarketplaces}
        />
      </Col>
    </Row>
  );
};

export default Marketplaces;
